import { render, staticRenderFns } from "./importdata-pab.vue?vue&type=template&id=2ad04252&scoped=true&"
import script from "./importdata-pab.vue?vue&type=script&lang=js&"
export * from "./importdata-pab.vue?vue&type=script&lang=js&"
import style0 from "./importdata-pab.vue?vue&type=style&index=0&id=2ad04252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad04252",
  null
  
)

export default component.exports